import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, Ref } from "vue"
import AppDetailPage from "@/components/layout/AppDetailPage.vue"
import UserAvatarGroup from "@/components/widgets/common/UserAvatarGroup.vue"
import Tab from "@/components/widgets/Tabs/Tab.vue"
import Tabs from "@/components/widgets/Tabs/Tabs.vue"
import Home from "@/modules/Missions/components/Details/Overview/Overview.vue"
import ConsultantInvoice from "@/modules/Missions/components/Details/Billing/ConsultantBilling.vue"
import Documents from "@/modules/Missions/components/Details/Documents/Documents.vue"
import { useQuery } from "@vue/apollo-composable"
import {
  MyMissionsQuery,
  MyMissionsQueryQuery,
  MyMissionsQueryQueryVariables,
  ConsultantMissionLifecycle,
  MissionLifecycleFragmentFragment,
  ClientMissionLifecycleFragmentFragment,
} from "@/gql"
import useRouter from "@/router/useRouter"
import MissionToolbar from "@/modules/Missions/components/Details/MissionToolbar/MissionToolbar.vue"
import { useUrl } from "@/hooks/useUrl"
import { PageState } from "@/constants"
import { usePageState } from "@/hooks/usePageState"
import PageStateError from "@/components/widgets/common/PageStateError.vue"
import { provideMissionLifecycleContext } from "@/modules/Missions/hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'ConsultantDetailPage',
  setup(__props) {

const { router, routes } = useRouter()

const { loading, result, refetch, onError, onResult } = useQuery<
  MyMissionsQueryQuery,
  MyMissionsQueryQueryVariables
>(MyMissionsQuery, {
  filter: {
    idIn: [router.currentRoute.params.id],
  },
  per: 1,
})

const pageState = ref(PageState.Loading)

const { handlePageErrorState } = usePageState(pageState)

onError((error) => {
  handlePageErrorState(error)
})

onResult((result) => {
  if (result?.data?.myMissions?.data.length === 0) {
    pageState.value = PageState.Empty
  }
})

const refetchQueries = computed(() => {
  return [
    {
      query: MyMissionsQuery,
      variables: {
        filter: {
          idIn: [router.currentRoute.params.id],
        },
        per: 1,
      },
    },
  ]
})

const mission = computed(() => {
  if (!result.value?.myMissions?.data.length) return null
  const missionData = result.value.myMissions.data[0]

  return missionData as ConsultantMissionLifecycle
})

provideMissionLifecycleContext({
  mission: mission as unknown as Ref<
    MissionLifecycleFragmentFragment | ClientMissionLifecycleFragmentFragment | null
  >,
  refetch,
})

const collaborators = computed(() => {
  return mission.value ? mission.value.collaborators : []
})

const tabs = [
  {
    label: "Home",
    key: "home",
  },
  {
    label: "Invoices",
    key: "invoices",
  },
  {
    label: "Documents",
    key: "documents",
  },
]

const projectLink = computed(() => {
  return useUrl(routes.MissionDetail, { id: mission.value?.id.toString() }).href
})

provideMissionLifecycleContext({ mission: mission })

return { __sfc: true,router, routes, loading, result, refetch, onError, onResult, pageState, handlePageErrorState, refetchQueries, mission, collaborators, tabs, projectLink, AppDetailPage, UserAvatarGroup, Tab, Tabs, Home, ConsultantInvoice, Documents, MissionToolbar, PageState, PageStateError }
}

})